import React , {useState, useEffect} from 'react';
import {useForm} from 'react-hook-form';
import clinicService from '../../../../../services/clinic.service';
import {toast} from 'react-toastify'

const ClinicReminderSettingsForm = (props) => {
    const {register, handleSubmit, setValue, formState: {errors}} = useForm(
        {
            defaultValues:{
              "id":props.reminderSettings.id,
              "clinicId":props.reminderSettings.clinicId,
              "apptReminder": props.reminderSettings.apptReminder,
              "isPrebookedReminder" : props.reminderSettings.isPrebookedReminder,
              "isFirstReminder":props.reminderSettings.isFirstReminder,
              "isSecondReminder": props.reminderSettings.isSecondReminder,
              "isLastReminder":props.reminderSettings.isLastReminder,
              "isSameDayReminder":props.reminderSettings.isSameDayReminder,
              "isClReminder":props.reminderSettings.isClReminder,
              "isClReorder" : props.reminderSettings.isClReorder,

              "isBirthday" :props.reminderSettings.isBirthday,
              "isThankyou" : props.reminderSettings.isThankyou,
              "isWelcome":props.reminderSettings.isWelcome,
              "isEmail":props.reminderSettings.isEmail,
              "isSms":props.reminderSettings.isSms,
              "isCall":props.reminderSettings.isCall,
              "isApptSummary" : props.reminderSettings.isApptSummary,
            
              "isClGlSummary":props.reminderSettings.isClGlSummary,
              "reminderTime":props.reminderSettings.reminderTime,
              "sameDayReminderTime":props.reminderSettings.sameDayReminderTime,
              "daysPrebookReminder":props.reminderSettings.daysPrebookReminder,
              "daysFirstReminder":props.reminderSettings.daysFirstReminder,
              "daysSecondReminder":props.reminderSettings.daysSecondReminder,
              "minutesToAppt":props.reminderSettings.minutesToAppt,

              "callPreference" : props.reminderSettings.callPreference,
              "apptSummary" : props.reminderSettings.apptSummary,
              "isGlPickup" : props.reminderSettings.isGlPickup,
              "isClPickup" : props.reminderSettings.isClPickup,
              "isFollowup" : props.reminderSettings.isFollowup,
           
            }
        }
    );
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [reminderSettings, setReminderSettings] = useState({});

    useEffect(() => {
        setReminderSettings(props.reminderSettings);
       // console.log(props)
    }, [props.reminderSettings]);
    const handleBool = (boolValue)=>{
      if(boolValue === true || boolValue ===1){
        return 1;
      }

      return 0;
    }
    const onSubmit = (data) => {
    
        setIsLoading(true);
        let newdata = data
        newdata.id=data.id
        newdata.clinicId=data.clinicId
        newdata.apptReminder= handleBool(data.apptReminder)
        newdata.isPrebookedReminder= handleBool(data.isPrebookedReminder)
        newdata.isFirstReminder= handleBool(data.isFirstReminder)
        newdata.isSecondReminder= handleBool(data.isSecondReminder)
        newdata.isLastReminder=handleBool(data.isLastReminder)
        newdata.isSameDayReminder=handleBool(data.isSameDayReminder)
        newdata.isClReminder=handleBool(data.isClReminder)
        newdata.isClReorder= handleBool(data.isClReorder)
        newdata.isBirthday=handleBool(data.isBirthday)
        newdata.isThankyou= handleBool(data.isThankyou)
        newdata.isWelcome=handleBool(data.isWelcome)
        newdata.isEmail=handleBool(data.isEmail)
        newdata.isSms=handleBool(data.isSms)
        newdata.isCall=handleBool(data.isCall)
        newdata.isApptSummary= handleBool(data.isApptSummary)            
        newdata.isClGlSummary=handleBool(data.isClGlSummary)
        newdata.reminderTime=data.reminderTime
        newdata.sameDayReminderTime=data.sameDayReminderTime
        newdata.daysPrebookReminder=data.daysPrebookReminder
        newdata.daysFirstReminder=data.daysFirstReminder
        newdata.daysSecondReminder=data.daysSecondReminder
        newdata.minutesToAppt=data.minutesToAppt
        newdata.callPreference= data.callPreference
        newdata.apptSummary= data.apptSummary
        newdata.isGlPickup= handleBool(data.isGlPickup)
        newdata.isClPickup= handleBool(data.isClPickup)
        newdata.isFollowup= handleBool(data.isFollowup)
       
        //console.log(newdata)
      
    
       
        clinicService.updateReminderSettings(props.reminderSettings.clinicId, newdata)
            .then(res => {
                //console.log(res)
                setIsLoading(false);
                setIsSuccess(true);
                setIsError(false);
                setErrorMessage('');
                toast.success("Updated Reminder Settings",{
                  position:toast.POSITION.BOTTOM_RIGHT
                })

                props.updatesettings(res.data)
                //setReminderSettings(res.data);
                
            })
            .catch(err => {
                setIsLoading(false);
                setIsSuccess(false);
                setIsError(true);
                toast.error("Error Updating Reminder SEttings",{
                  position:toast.POSITION.BOTTOM_RIGHT
                })
               // console.log(err)
               // setErrorMessage(err.response.data.message);
            });

          
    }; 


    return ( 
        <>
        <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-md-6">
                 <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("apptReminder")}
                        />
                      <label htmlFor="apptReminder" className="form-check-label">Appointment Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isPrebookedReminder")}
                        />
                      <label htmlFor="isPrebookedReminder" className="form-check-label">Prebooked Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isFirstReminder")}
                        />
                      <label htmlFor="isFirstReminder" className="form-check-label">First Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isSecondReminder")}
                        />
                      <label htmlFor="isSecondReminder" className="form-check-label">Second Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isLastReminder")}
                        />
                      <label htmlFor="isLastReminder" className="form-check-label">Last Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isSameDayReminder")}
                        />
                      <label htmlFor="isSameDayReminder" className="form-check-label">Same Day Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isClReminder")}
                        />
                      <label htmlFor="isClReminder" className="form-check-label">Contact Lens Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isClReorder")}
                        />
                      <label htmlFor="isClReorder" className="form-check-label">Contact Lens Reorder</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isBirthday")}
                        />
                      <label htmlFor="isBirthday" className="form-check-label">Birthday Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isThankyou")}
                        />
                      <label htmlFor="isThankyou" className="form-check-label">Thank you Reminder</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isWelcome")}
                        />
                      <label htmlFor="isWelcome" className="form-check-label">Welcome Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isEmail")}
                        />
                      <label htmlFor="isEmail" className="form-check-label">Email Reminder</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isSms")}
                        />
                      <label htmlFor="isSms" className="form-check-label">Sms Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isCall")}
                        />
                      <label htmlFor="isCall" className="form-check-label">Call Reminders</label>
                  </div>
                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isApptSummary")}
                        />
                      <label htmlFor="isApptSummary" className="form-check-label">Appointment Summary</label>
                  </div>

                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isGlPickup")}
                        />
                      <label htmlFor="isGlPickup" className="form-check-label">Glass Pickup</label>
                  </div>

                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isClPickup")}
                        />
                      <label htmlFor="isClPickup" className="form-check-label">Contact Lens Pickup</label>
                  </div>

                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isFollowup")}
                        />
                      <label htmlFor="isFollowup" className="form-check-label">Followup</label>
                  </div>

                  <div className="form-check form-switch mb-2">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isClGlSummary")}
                        />
                      <label htmlFor="isClGlSummary" className="form-check-label">Contact Lens & Glass Summary</label>
                  </div>
            </div>
            <div className="col-md-6">
               
               <div className="row">
                   <div className="col-12 mb-3">
                       <label htmlFor="callPreference" className="form-label"> Call Preference</label>
                       <select className='form-select'   {...register("callPreference")}>
                          <option value="0">Disable</option>
                          <option value="1">Clinic</option>
                          <option value="2">Both</option>
                       </select>
                      
                   </div>
                   <div className="col-12 mb-3">
                       <label htmlFor="apptSummary" className="form-label"> Appointment Summary</label>
                       <select className='form-select'   {...register("apptSummary")}>
                          <option value="0">Disable</option>
                          <option value="1">Clinic</option>
                          <option value="2">Both</option>
                       </select>
                      
                   </div>
                   <div className="col-12 mb-3">
                       <label htmlFor="reminderTime" className="form-label"> Reminder Time</label>
                       <input
                            type="time"
                            className="form-control"
                            {...register("reminderTime")}
                            />
                   </div>
                   <div className="col-12 mb-3">
                       <label htmlFor="sameDayReminderTime" className="form-label"> Same Day Reminder Time</label>
                       <input
                            type="time"
                            className="form-control"
                            {...register("sameDayReminderTime")}
                            />
                   </div>
                   <div className="col-12 mb-3">
                       <label htmlFor="" className="form-label"> Days To Send Prebook Reminder</label>
                       <input
                            type="number"
                            className="form-control"
                            {...register("daysPrebookReminder")}
                            />
                   </div>
                   <div className="col-12">
                       <label htmlFor="" className="form-label"> Days to Send First Reminder</label>
                       <input
                            type="number"
                            className="form-control"
                            {...register("daysFirstReminder")}
                            />
                   </div>
                   <div className="col-12">
                       <label htmlFor="" className="form-label"> Days to Send Second Reminder</label>
                       <input
                            type="number"
                            className="form-control"
                            {...register("daysSecondReminder")}
                            />
                   </div>
                   <div className="col-12">
                       <label htmlFor="" className="form-label"> Minutes Earlier</label>
                       <input
                            type="number"
                            className="form-control"
                            {...register("minutesToAppt")}
                            />
                   </div>
               </div>
            </div>
            <div className="col-12 text-center mt-3">
                    <button className="btn btn-secondary" type="submit">Save</button>
            </div>
        </form>
        </>
     );
}
 
export default ClinicReminderSettingsForm;